export default __webpack_public_path__ + "static/media/icon_layout.870b15ec.svg";